import {
  HelpCenterActionTypes,
  HelpCenterState,
  SET_HELP_CENTER_STATE,
} from "./types";

const DEFAULT_STATE: HelpCenterState = {
  isFetching: false,
  search: "",
  articles: [],
};

export { DEFAULT_STATE };

export default (
  state = DEFAULT_STATE,
  action: HelpCenterActionTypes
): HelpCenterState => {
  switch (action.type) {
    case SET_HELP_CENTER_STATE:
      return {
        ...state,
        ...action.state,
      };
    default:
      return state;
  }
};
